export const setVendor = (vendorName) => {
    return async function (dispatch, getState){
        await dispatch({
            type: "SET_VENDOR",
            payload: vendorName
        });
    }
};